###
# Вспомогательный объект, представляющий группу конфигурационных параметров
###
OptionGroup = Em.Object.extend
  # Расширенный массив items c флагом include
  itemsWithPresence: (->
    console.log @get('items')
    @get('items').map (item) ->
      itemObject = Em.Object.create()
      itemObject.setProperties(item)
      itemObject.set 'include', false
      itemObject.set 'amount', 0

      itemObject
  ).property('items')

  # Только выбранные элементы
  includedItems: Em.computed.filterBy('itemsWithPresence', 'include', true)

  # Есть ли выбранные?
  included: Em.computed.gt('includedItems.length', 0)

  # Последний выбранный элемент
  lastSelectedItem: null

  isStepper: Em.computed.equal('view_type', 'stepper')

  isSingleItemSelect: (->
    min       = @get 'min'
    max       = @get 'max'
    multiple  = @get 'multiple'

    not multiple or ((max is 1) and (min is 1))
  ).property(
    'min',
    'max',
    'multiple'
  )

  # Список выбранных элементов через запятую
  joinedItemNames: (->
    @get('includedItems')
    .map (item) -> item.get('name')
    .join ', '
  ).property('includedItems.[]')

  # Цена конфигурации в данной группе
  price: (->
    @get('includedItems')
    .reduce (val, item) ->
      val + if item.get('amount') == 0 then Number(item.get('price')) else Number(item.get('price')*item.get('amount'))
    , 0
  ).property('includedItems.@each.price', 'includedItems.@each.amount')

  # валидационное сообщение
  validation: (->
    groupName = @get 'name'
    count     = @get 'includedItems.length'
    min       = @get 'min'
    max       = @get 'max'
    multiple  = @get 'multiple'

    if @get('isStepper')
      error = null
      min = min ? 0
      max = max ? 0
      count = 0
      @get('includedItems').forEach (item) =>
        imax = Math.max(item.get('max'), max)
        imin = Math.min(item.get('min'), min)
        imin = imin ? 0
        imax = imax ? 0
        amount = item.get('amount')
        count += amount
        if (imin > amount or amount > imax)
          error = @get('env').translate('configurator.validations.multiple_select', { min: imin, max: imax, groupName: item.get('name') })
          return false
      return error if error
      if count > max or count < min
        return @get('env').translate('configurator.validations.multiple_select', { min, max, groupName })


    else
      if @get('isSingleItemSelect')
        if count != 1
          return @get('env').translate('configurator.validations.single_select', { groupName })
      else
        min = min ? 0
        max = max ? 0
        limitedItemsAmount = true

        limitedItemsAmount = false if min == 0 && max == 0
        if limitedItemsAmount and (min > count or count > max)
          return @get('env').translate('configurator.validations.multiple_select', { min, max, groupName })

    return null
  ).property(
    'includedItems.length',
    'includedItems.@each.amount',
    'name',
    'min',
    'max',
    'multiple'
  )



App.ItemConfiguratorSectionComponent = Em.Component.extend
  env: Em.inject.service('environment')

  # Переданное блюдо или элемент заказа
  # Работает в 2х режимах: создание и редактирование
  dish: null
  item: null

  isNewItem: (->
    @get('dish') != null
  ).property('dish', 'item')

  comment: ''
  optionGroups: []

  validations: (->
    @get('optionGroups')
    .mapBy('validation')
    .reject (v) -> Em.isEmpty(v)
  ).property('optionGroups.@each.validation')

  # Выбранные группы
  includedGroups: Em.computed.filterBy('optionGroups', 'included', true)

  ###
  # Полная цена кофигурации
  ###
  configPrice: (->
    @get('optionGroups').reduce (val, item) ->
      val + item.get('price')
    , 0
  ).property('optionGroups.@each.price')

  dishPrice: (->
    if @get('isNewItem')
      @get('dish.restaurantPrice')
    else
      @get('item.dish_price')
  ).property(
    'isNewItem',
    'dish.price',
    'item.dish_price')

  ###
  # Полная цена получившегося блюда
  ###
  totalPrice: (->
    Number(@get('dishPrice')) + @get('configPrice')
  ).property(
    'dishPrice',
    'configPrice')

  saveButtonText: (->
    if @get('isNewItem')
      # todo i18n
      'Добавить'
    else
      # todo i18n
      'Сохранить'
  ).property('isNewItem')

  onFocusChanged: (->
    console.log @get('item'), @get('dish.restaurantOptions')
    if @get('focused')
      # Активация конфигуратора:
      # обнулить опции и сформировать группы опций
      if @get('isNewItem')
        @set('comment', '')
      else
        @set('comment', @get('item.comment') )

      # Конфигуратор берем либо из блюда, либо из элемента
      options = @get('dish.restaurantOptions') || @get('item.configurator')

      options = [] if !Em.isArray(options)

      groups = options.map (group) =>
        OptionGroup.create(Em.merge(group, { env: @get('env')}))

      # В случае редактирования, предзаполняем выбранные опции
      if not @get('isNewItem')
        presentConfig = @get('item.config') || []

        presentConfig.forEach (cc) =>
          matchedGroup = groups.filter((g) => Em.get(g, 'name') is Em.get(cc, 'name'))[0]
          return unless matchedGroup

          (Em.get(cc, 'value') || []).forEach (value) =>
            matchedOption = Em.get(matchedGroup, 'itemsWithPresence')
              .filter((i) => Em.get(i, 'name') is Em.get(value, 'name'))
              .forEach (i) =>
                i.set('include', true)


      @set('optionGroups', groups)

  ).observes('focused')

  isntValid: Em.computed.oneWay('validations.firstObject')

  makeCompatibleConfig: ->
    config = @get('includedGroups').map (group) ->
      groupId    = group.get('id')
      groupName  = group.get('name')

      value = group.get('includedItems').map (item) ->
        id    = Number(item.get('id'))
        price = Number(item.get('price'))
        name  = item.get('name')
        amount = if item.get('amount') == 0 then 1 else item.get('amount')

        { id, name, price, amount }
      { id: groupId, name: groupName, value }

    if Em.isEmpty(config) then null else config

  actions:
    decrementItem: (option, item) ->
      return if item.get('amount') == 0
      item.set('amount', item.get('amount') - 1)
      item.set('include', false) if item.get('amount') == 0

    incrementItem: (option, item) ->
      return if (item.get('amount') + 1) > item.get('max')
      item.set('amount', item.get('amount') + 1)
      item.set('include', true)

    cancel: ->
      @sendAction('onCancel')
      false

    finish: ->
      return if @get('isntValid')

      config  = @makeCompatibleConfig()
      comment = if @get('comment') == '' then null else @get('comment')
      dish    = @get('dish')

      @sendAction('onConfigurationSelect', dish, config, comment)
      false
